import axios from "axios"
import { BACKEND } from "../../config/configEnvs"
import { toast } from "react-toastify"

const getData = async ({setData, setTotalDocs, setTotalPages, route, limit = 10, page = 1, params, showToast = false}) => {
  try {
    const response = await axios.get(`${BACKEND}/api/${route}?limit=${limit}&page=${page}${params}`)
    
    setData(response.data.docs)

    if (setTotalPages) setTotalPages(response.data.totalPages)
    if (setTotalDocs) setTotalDocs(response.data.totalDocs)
    
    if (showToast) toast.success("Datos obtenidos con éxito")
  } catch (e) {
    if (showToast) toast.error("Error al obtener la data: " + e)
  }
}

export default getData